/* eslint-disable react/prop-types */
import React from 'react'
import styled from 'styled-components'
import { Spin } from 'antd'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  ${({ loadingMini }) => loadingMini && `
    position: absolute;
    height: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 3;
    width: 100%;
    background: rgba(0,0,0,0.2)
  `
}
`

const Loading = (props) => (
  <Wrapper {...props}>
    <Spin size="large" />
  </Wrapper>
)

export default Loading
